import React from 'react';
import { Button, Modal } from '@scale/scaleui';
// eslint-disable-next-line restrict-imports/restrict-imports
import Box from '@mui/material/Box';

interface IUpdateCSVCampaignModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const UpdateCSVCampaignModal: React.FC<IUpdateCSVCampaignModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal open={open} title="Confirm Update and Send" onClose={onClose}>
      Are you sure you want to update and send this campaign?
      <Box display={'flex'} justifyContent={'flex-end'} gap={1000} sx={{ gap: 2, paddingTop: 1.5 }}>
        <Button size="lg" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="lg" variant="primary" onClick={onSubmit}>
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};

export default UpdateCSVCampaignModal;
